//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/SketchGeometricConstraint.js";
let d=[[[0,"PatternType",0,0]],[[[],"GetRelationScope",{R_:{scope:''}},0,0],[["numIndices","indicesX"],"GetRelationScopeIndices",{R_:{indicesY:""}},0,0]],[]];
SPLM.SketchPattern = class extends SPLM.SketchGeometricConstraint{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.SketchPattern";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.SketchPattern.Type = Object.freeze({
    "Linear" : "Linear", "Circular" : "Circular", "Mirror" : "Mirror", "Rectangular" : "Rectangular", "General" : "General"});

SPLM.SketchPattern.InstanceControl = Object.freeze({
    "FullCircle" : "FullCircle", "NumberOffset" : "NumberOffset"});

SPLM.SketchPattern.RelationScope = Object.freeze({
    "Input" : "Input", "None" : "None", "Specified" : "Specified", "All" : "All"});

export default SPLM;